export const initialResearchState = (isTile: boolean) => ({
  isFetching: false,
  totalCount: 0,
  collection: [],
  page: 1,
  perPage: isTile ? 10 : 25,
  sortBy: 'publishedAt',
  sortOrder: 'desc',
});

export const initialResearchServerSideData = (isTile: boolean) => ({
  all: {
    count: 0,
    researchCollection: initialResearchState(isTile),
  },
  byGroup: {},
});

export const defaultDictionaries = ({
  researchDocumentGroupList: [],
});
